class BlockListingAppart {
	constructor() {
		this.blocks = document.querySelectorAll('.block-appart .swiper');

		if (this.blocks.length > 0) {
			this.init();
		}
	}

	init() {
		this.blocks.forEach((slider) => {
			const swiper = new Swiper(slider, {
				speed: 400,
				spaceBetween: 30,
				loop: true,
				grabCursor: true,
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					clickable: true,
				},
			});
		});
	}
}